"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _makeMethod = require("@/api/goods/makeMethod");
var _shopList = require("@/api/shop/shopList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
// import { get } from 'sortablejs'
var _default = exports.default = {
  name: 'makeMethodEstimateInfo',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  props: {
    makeMethodId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: [],
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        dataId: null,
        storeId: null
      },
      resPath: process.env.VUE_IMAGE_PATH,
      shopList: []
    };
  },
  created: function created() {
    this.getList();
  },
  computed: {},
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      this.listQuery.dataId = this.makeMethodId;
      (0, _makeMethod.getMakeMethodEstimateInfo)(this.listQuery).then(function (response) {
        if (response) {
          _this.dataList = response.data;
        }
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.limit = size;
      this.listQuery.page = 1;
      this.getList();
    }
  }
};